'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('alignItems', 'align');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/align-items.js
// module id = 104
// module chunks = 35783957827783 114276838955818 214865505688126